const offlineUtils = {
  isOnline: () => navigator.onLine,
};

export default offlineUtils;
